import routes from '@/routes';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useLanguage from '@/hooks/useLanguage';
import styles from './footer.module.css';

const Footer = (props) => {
  const {
    isFixed = false,
    isNegative = false,
  } = props;

  const { t } = useTranslation();
  const { localize } = useLanguage();

  const classNames = clsx(styles.footer, isFixed && styles.fixed, isNegative && styles.negative);

  return (
    <footer className={classNames}>
      <ul>
        <li><Link to={localize(routes.prices.path)}>{t('components.footer.items.prices')}</Link></li>
        <li><Link to={localize(routes.disclosure.path)}>{t('components.footer.items.disclosure')}</Link></li>
        <li><Link to={localize(routes.agreement.path)}>{t('components.footer.items.agreement')}</Link></li>
        <li><Link to={localize(routes.privacy.path)}>{t('components.footer.items.privacy')}</Link></li>
      </ul>
    </footer>
  );
};

Footer.propTypes = {
  isFixed: PropTypes.bool,
  isNegative: PropTypes.bool,
};

export default Footer;
